<template>
  <div>
    <Address
      :type="2"
      :showRegistBtn="false"
      :showDeleteBtn="false"
      :showCancelBtn="false"
      :showCompleteMsg="false"
      v-on:updated="toNext()"
      v-on:sendInvalidsFlag="updateReadyAddressFlag"
      ref="address" />
    <Spacer :y="3"/>
    <div :class="styleClasses.btns">
      <button
        :class="[styleClasses.btn, styleClasses.secondary]"
        @click="toBack()">戻る</button>
      <button
        :class="[styleClasses.btn, styleClasses.primary]"
        :disabled="!flag.readySubmit"
        @click="submitAddress(1)">次に進む</button>
    </div>
  </div>
</template>

<script>
import Address from '@/components/parts/Address.vue';
import Spacer from '@/components/Spacer.vue';

export default {
  name: 'edit-subscription-delivery-address',
  components: {
    Address,
    Spacer,
  },
  props: {
    selectedCourse: String || null,
    customerDefaultSource: Object || null,
    deliveryAddress: Object || null,
    styleClasses: Object,
  },
  data() {
    return {
      flag: {
        readySubmit: false,
      },
    };
  },
  mounted() {
    if (!this.selectedCourse) this.$router.push('/edit/subscription/');
    else if (!this.customerDefaultSource) this.$router.push('/edit/subscription/payment-method/');
    else if (!this.selectedCourse.toLowerCase().includes('paper')) this.$router.push('/edit/subscription/confirm/');
  },
  methods: {
    toBack() {
      this.$router.push('/edit/subscription/payment-method/');
    },
    toNext() {
      this.$router.push('/edit/subscription/confirm/');
    },
    updateReadyAddressFlag(flag) {
      this.flag.readySubmit = flag;
    },
    submitAddress(flag) {
      this.$refs.address.submit(flag);
    },
  },
};
</script>

<style lang="scss" module="s">
.edit {
  text-decoration: underline;
  font-size: 12px;
}
.address_str {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
